import {stringify} from 'qs'
import {format} from 'utils'
import request from 'message-control/utils/request'
import api from 'message-control/common/api/session-tag'

export async function getList(params) {
    return request(`${api.getList.url}?${stringify(params)}`)
}

export async function create(payload = {}) {
    return request(api.create.url, {
        method: api.create.type,
        body: payload.body,
    })
}

export async function edit(payload = {}) {
    return request(format(api.edit.url, {id: payload.id}), {
        method: api.edit.type,
        body: payload.body,
    })
}

export async function remove(payload = {}) {
    return request(format(api.remove.url, {id: payload.id}), {
        method: api.remove.type,
        body: payload.body,
    })
}
